// DEPRECATED
module.exports = {
    primaryColorBase: '#2895cf',
    primaryColorPressed: '#5eb0db',
    primaryColorHover: '#7ebfe2',
    primaryColorInactive: '#7ebfe2',
    primaryColorDisabled: '#a9d5ec',

    mutedColorBase: '#1f5578',
    mutedColorPressed: '#57809a',
    mutedColorHover: '#7999ae',
    mutedColorInactive: '#7999ae',
    mutedColorDisabled: '#a5bbc9',

    accentColorBase: '#fec236',
    accentColorPressed: '#fed168',
    accentColorHover: '#feda86',
    accentColorInactive: '#feda86',
    accentColorDisabled: '#ffe7af',

    successColorBase: '#9ab93c',
    successColorPressed: '#b3cb6d',
    successColorHover: '#c2d58a',
    successColorInactive: '#c2d58a',
    successColorDisabled: '#d7e3b1',

    infoColorBase: '#2895cf',
    infoColorPressed: '#5eb0db',
    infoColorHover: '#7ebfe2',
    infoColorInactive: '#7ebfe2',
    infoColorDisabled: '#a9d5ec',

    warningColorBase: '#fb8c00',
    warningColorPressed: '#fca940',
    warningColorHover: '#fdba66',
    warningColorInactive: '#fdba66',
    warningColorDisabled: '#fdd199',

    dangerColorBase: '#f04a23',
    dangerColorPressed: '#f4775a',
    dangerColorHover: '#f6927b',
    dangerColorInactive: '#f6927b',
    dangerColorDisabled: '#f9b7a7',

    textColorPrimary: '#323232',
    textColorSecondary: '#727272',
    textColorDisabled: '#b6b6b6',

    redHover: '#b71c1c',
    blueHover: '#0277BD',

    textColorWhite: '#fff',
    textColorWhiteHover: 'rgba(255, 255, 255, 0.6)',
    textColorWhiteDisabled: 'rgba(255, 255, 255, 0.4)',


    coolBackgroundColor: 'radial-gradient(#2895cf, #111118) rgba(34,34,40,0.94)',

    eliteColor: '#001337',

    fontSizeTitle: '20px',
    fontWeightTitle: 'bold',

    fontSizeSubheader: '20px',
    fontWeightSubheader: 'normal',

    fontSizeBody: '14px',

    fontSizeCaption: '12px',
};
